var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAddFriendIcon = function SvgAddFriendIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#add-friend-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#add-friend-icon_svg__b)",
    d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22 18h5a2 2 0 1 1 0 4h-5v5a2 2 0 0 1-4 0v-5h-5a2 2 0 0 1 0-4h5v-5a2 2 0 1 1 4 0z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "add-friend-icon_svg__b",
    x1: 20,
    x2: 20,
    y1: 0,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07818C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17D3E5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "add-friend-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  })))));
};
export default SvgAddFriendIcon;